import { render } from "./Myteam.vue?vue&type=template&id=4780a11c&scoped=true"
import script from "./Myteam.vue?vue&type=script&lang=js"
export * from "./Myteam.vue?vue&type=script&lang=js"

import "./Myteam.vue?vue&type=style&index=0&id=4780a11c&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4780a11c"]])

export default __exports__